<!-- begin breadcrumb -->
<ol class="breadcrumb pull-right">
    <li class="breadcrumb-item"><a [routerLink]="['/inicio']">Inicio</a></li>
    <li class="breadcrumb-item">Declaraciones</li>
    <li class="breadcrumb-item active">Subir declaración</li>
</ol>
<!-- end breadcrumb -->

<!-- begin page-header -->
<h1 class="page-header"> <i class="{{icono}}"></i> {{ titulo }} <small> {{ descripcion }}</small></h1>
<!-- end page-header -->

<!-- begin row -->
<div class="row">
    <!-- Panel de carga de archivo -->
    <div class="col-12">
        <div class="panel panel-iatuch">
            <div class="panel-heading">
                <h4 class="panel-title"><i class="{{icono}}"></i> {{titulo}}</h4>
            </div>
            <div class="panel-body py-3">
                <!-- Formulario de carga -->
                <form #declaracionForm="ngForm" (ngSubmit)="onSubmit(declaracionForm)">
                    <div class="row">
                        <div class="col-lg-8 col-md-7">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-light border-right-0">
                                        <i class="fas fa-file-excel text-success"></i>
                                    </span>
                                </div>
                                <input type="text" class="form-control border-left-0" readonly 
                                       [value]="nombre_archivo || 'Ningún archivo seleccionado'"
                                       [class.text-muted]="!nombre_archivo">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" 
                                            ngbTooltip="Seleccionar archivo Excel" 
                                            (click)="adjuntar()">
                                        <i class="fas fa-folder-open"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-5 mt-2 mt-md-0">
                            <div class="btn-group w-100" role="group">
                                <button type="submit" class="btn btn-success" 
                                        ngbTooltip="Procesar archivo" 
                                        [disabled]="!nombre_archivo">
                                    <i class="fas fa-upload"></i> Subir
                                </button>
                                <a href="./assets/plantillas/plantilla_declaraciones.xlsx" 
                                   class="btn btn-outline-primary"
                                   ngbTooltip="Descargar plantilla">
                                    <i class="fas fa-download"></i> Plantilla
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Input file oculto -->
                    <input #archivo_declaracion type="file" id="btn_archivo_declaracion" 
                           name="archivo[]" class="d-none" 
                           (change)="fileChageEvent($event)" required>
                    
                    <!-- Indicador de carga -->
                    <div *ngIf="cargando" class="mt-3">
                        <div class="alert alert-info border-0 shadow-sm py-2 mb-0">
                            <div class="d-flex align-items-center">
                                <div class="spinner-border spinner-border-sm text-info mr-3" role="status">
                                    <span class="sr-only">Cargando...</span>
                                </div>
                                <div>
                                    <strong>Procesando archivo...</strong>
                                    <div class="small text-muted">Por favor espere mientras se procesan los datos.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <!-- Alerta de plazo -->
                <div *ngIf="plazo" class="alert {{plazo.color}} border-0 shadow-sm py-2 mt-3 mb-0">
                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                    <div class="d-flex align-items-center">
                        <i class="fas {{plazo.icon}} fa-lg mr-3"></i>
                        <div>
                            <strong>Atención!</strong> 
                            <span class="ml-1">{{plazo.texto}} {{(plazo.fecha | date:'dd/MM/yyyy HH:mm')+" Hrs"}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Panel de resultados -->
    <div class="col-12" *ngIf="declaraciones">
        <div class="panel panel-iatuch">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <i class="fas fa-chart-line mr-2"></i>Resultados del Procesamiento
                </h4>
            </div>
            <div class="panel-body py-3">
                <!-- Mensaje de estado -->
                <div class="row mb-3" *ngIf="mensaje">
                    <div class="col-12">
                        <div class="alert {{mensaje.color}} border-0 shadow-sm py-2 mb-0">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center flex-grow-1">
                                    <i class="fa {{mensaje.icon}} fa-lg mr-3"></i>
                                    <div class="flex-grow-1">
                                        <div class="font-weight-bold mb-1">{{mensaje.texto}}</div>
                                        <div *ngIf="lista_errores" class="small">
                                            <span *ngFor="let le of lista_errores; let last = last">
                                                • {{le}}<span *ngIf="!last"> </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="ml-3" *ngIf="estado_respuesta">
                                    <a [routerLink]="['/verdeclaracion']" 
                                       class="btn btn-sm btn-outline-primary">
                                        <i class="fas fa-eye"></i> Ver Declaración
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Estadísticas compactas -->
                <div class="row mb-3">
                    <div class="col-xl-3 col-lg-6 col-sm-6 mb-2">
                        <div class="card border-0 shadow-sm h-100">
                            <div class="card-body py-2 px-3">
                                <div class="d-flex align-items-center">
                                    <div class="bg-primary text-white rounded d-flex align-items-center justify-content-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-list-ol"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <div class="text-primary font-weight-bold h5 mb-0">{{totalRegistrosFormatted}}</div>
                                        <div class="text-muted small">Total Registros</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-sm-6 mb-2">
                        <div class="card border-0 shadow-sm h-100">
                            <div class="card-body py-2 px-3">
                                <div class="d-flex align-items-center">
                                    <div class="bg-success text-white rounded d-flex align-items-center justify-content-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-check-circle"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <div class="text-success font-weight-bold h5 mb-0">{{registrosValidosFormatted}}</div>
                                        <div class="text-muted small">Válidos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-sm-6 mb-2">
                        <div class="card border-0 shadow-sm h-100">
                            <div class="card-body py-2 px-3">
                                <div class="d-flex align-items-center">
                                    <div class="bg-danger text-white rounded d-flex align-items-center justify-content-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <div class="text-danger font-weight-bold h5 mb-0">{{registrosConErroresFormatted}}</div>
                                        <div class="text-muted small">Con Errores</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-sm-6 mb-2">
                        <div class="card border-0 shadow-sm h-100">
                            <div class="card-body py-2 px-3">
                                <div class="d-flex align-items-center">
                                    <div class="bg-info text-white rounded d-flex align-items-center justify-content-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-dollar-sign"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <div class="text-info font-weight-bold h6 mb-0">${{totalGeneralFormatted}}</div>
                                        <div class="text-muted small">Total General</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Tabla de declaraciones -->
                <div class="card border-0 shadow-sm">
                    
                    <div class="card-body p-0">
                        <div class="table-responsive" style="max-height: 350px; overflow-y: auto;">
                            <table class="table table-sm table-hover mb-0">
                                <thead class="thead-light sticky-top">
                                    <tr>
                                        <th width="8%" class="border-0 font-weight-bold py-2">#</th>
                                        <th width="18%" class="border-0 font-weight-bold py-2">RUT</th>
                                        <th width="35%" class="border-0 font-weight-bold py-2">Razón Social</th>
                                        <th width="15%" class="border-0 font-weight-bold py-2">Tipo</th>
                                        <th width="17%" class="border-0 font-weight-bold text-right py-2">Monto</th>
                                        <th width="7%" class="border-0 font-weight-bold text-center py-2">Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let dec of declaraciones; let i = index" 
                                        [ngClass]="{'bg-light border-left border-danger': dec.estado == 'false'}">
                                        <td class="align-middle text-muted py-1">{{dec.fila + 1}}</td>
                                        <td class="align-middle font-weight-medium py-1">{{dec.rut}}</td>
                                        <td class="align-middle py-1">{{dec.nombre}}</td>
                                        <td class="align-middle py-1">
                                            <span class="badge badge-light border">{{dec.tipo_ing_egr}}</span>
                                        </td>
                                        <td class="text-right align-middle font-weight-bold py-1">
                                            ${{dec.monto | number:'1.0-0'}}
                                        </td>
                                        <td class="text-center align-middle py-1">
                                            <i *ngIf="dec.estado == 'true'"
                                               class="fas fa-check-circle text-success"
                                               ngbTooltip="Registro válido"
                                               style="cursor: help;"></i>
                                            <i *ngIf="dec.estado == 'false'" 
                                               class="fas fa-exclamation-triangle text-danger"
                                               [ngbTooltip]="dec.mensaje_validacion"
                                               style="cursor: help;"></i>
                                        </td>
                                    </tr>
                                </tbody>
                                
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end row -->
